import { createContext } from "react";

// The rich-text fields of an answer that a saved answer can replace.
export type SavedAnswerField = "textAnswer" | "comment";
export type SavedAnswerFieldVersions = Partial<
  Record<SavedAnswerField, number>
>;

// Question id -> field -> how many times a saved answer replaced the form's
// copy of that field (TF-1786). A new number remounts that field's editor.
const SavedAnswerVersionsContext = createContext<
  Record<number, SavedAnswerFieldVersions>
>({});

// The versions of one question. AssessmentQuestionItem provides it.
export const QuestionSavedAnswerVersionsContext =
  createContext<SavedAnswerFieldVersions>({});

export default SavedAnswerVersionsContext;
